<template>
  <q-dialog v-if="getIsOpenModal" v-model="isOpenModal" @hide="handlerCancel()">
    <q-card class="card-content">
      <q-card-section class="row items-center">
        <span class="q-ml-sm q-px-lg modal-text">{{ modalText }}</span>
      </q-card-section>
      <q-card-section v-if="!selectedImage" class="loading-wrapper">
        <div>
          <q-spinner color="primary" size="3em" />
        </div>
      </q-card-section>
      <q-card-section v-if="selectedImage">
        <q-select
          v-model="selectedImage"
          class="q-ml-sm q-px-lg"
          outlined
          use-input
          input-debounce="0"
          :options="imagesList"
          @update:model-value="(val) => onSelectChange(val)"
          @filter="filterFn"
        />
      </q-card-section>
      <q-card-section class="flex justify-center" v-if="selectedImage">
        <q-img
          :src="baseImageURL.concat(selectedImage)"
          spinner-color="primary"
          class="fit-image"
        />
      </q-card-section>
      <q-card-section v-if="selectedImage">
        <span class="flex justify-center items-center">
          <q-btn
            flat
            @click="() => clickToCopy(baseImageURL.concat(selectedImage))"
          >
            <font-awesome-icon icon="fa-copy" size="xl" color="gray" />
          </q-btn>
          {{ baseImageURL.concat(selectedImage) }}
        </span>
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat label="Cancel" color="primary" @click="handlerCancel" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { copyToClipboard } from "quasar";
import { AppConfig } from "@/app.config";

export default {
  name: "SelectImageModal",

  props: {
    modalText: {
      require: true,
      default: "Choose your image!",
    },
  },

  data() {
    return {
      baseImageURL: "",
      selectedImage: "",
      imagesList: [],
      allImagesList: [],
      isOpenModal: null,
    };
  },

  async mounted() {
    this.isOpenModal = this.getIsOpenModal;
    if (this.getIsOpenModal) {
      await this.actionGetImages().then((response) => {
        this.imagesList = response;
        this.allImagesList = response;
        if (response) this.selectedImage = response[0];
      });
      this.baseImageURL = AppConfig.aarpBlob + (await this.getEnvFolder());
    }
  },

  computed: {
    ...mapGetters({ getIsOpenModal: "selectImage/getIsOpenModal" }),
    ...mapGetters({
      getEnv: "selectEnv/getEnv",
    }),
  },

  methods: {
    ...mapActions({
      setOpenModal: "selectImage/setOpenModal",
      actionGetImages: "selectImage/actionGetImages",
    }),

    async getEnvFolder() {
      if (this.getEnv === "stage") {
        return "arenax-aarp/stage/images/";
      }
      return "arenax-aarp/production/images/";
    },

    clickToCopy(val) {
      copyToClipboard(val)
        .then(() => {
          this.$q.notify({
            type: "positive",
            message: `Text Copied`,
          });
        })
        .catch(() => {
          // fail
        });
    },

    handlerCancel() {
      this.isOpenModal = false;
      this.setOpenModal(false);
    },

    onSelectChange(val) {
      this.selectedImage = val;
    },

    filterFn(val, update) {
      if (val === "") {
        update(() => {
          this.imagesList = this.allImagesList;
        });
        return;
      }

      update(() => {
        const needle = val.toString().toLowerCase();
        this.imagesList = this.allImagesList.filter(
          (img) => img.toString().toLowerCase().indexOf(needle) > -1
        );
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.card-content {
  min-width: 1140px !important;
}

.modal-text {
  margin-top: 20px;
  font-weight: bold;
  font-size: 24px;
}

.url-header {
  font-weight: bold;
}

.fit-image {
  max-width: 756px;
  height: auto;
  object-fit: fill;
  border: solid 3px $primary;
}

.loading-wrapper {
  min-height: 600px;
  position: relative;
  div {
    position: absolute;
    left: 50%;
    top: 30%;
  }
}
</style>
